import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useBuildInfoStyles = makeStyles(() =>
  createStyles({
    root: {
      maxWidth: 300,
      position: 'fixed',
      bottom: 20,
      right: 20,
      zIndex: 1000
    },

    content: {
      '&:last-child': {
        paddingBottom: 16
      }
    },

    typography: {
      fontSize: 14
    },

    closeButton: {
      position: 'absolute',
      right: 0
    }
  })
)
